import st from './heading.module.scss';
import cn from "classnames";

interface HeadingProps {
    children: string
}

const Heading = {
    Section: ({children}: HeadingProps) => <h2 className={cn(st['heading'], st['heading--section'])}>{children}</h2>,
    Card: ({children}: HeadingProps) => <h3 className={cn(st['heading'], st['heading--card'])}>{children}</h3>,
    CardSubHeading: ({children}: HeadingProps) => <h4 className={cn(st['heading'], st['heading--card-subheading'])}>{children}</h4>,
};

export default Heading;